import { render, staticRenderFns } from "./NotificationsBellButton.vue?vue&type=template&id=302591cd"
import script from "./NotificationsBellButton.vue?vue&type=script&lang=js"
export * from "./NotificationsBellButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports